import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { Location } from "@reach/router"

import { PasswordReset } from "gatsby-theme-gba"

const PasswordResetEditable = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Location>
      {({ location }) => (
        <PasswordReset
          hash={location.hash.substr(location.hash.indexOf("=") + 1)}
          heading={blok.heading}
          subHeading={blok.subHeading}
          buttonText={blok.buttonText}
        />
      )}
    </Location>
  </div>
)

export default PasswordResetEditable
